import { AxiosInstance } from 'axios'
import axiosStandard from './standard'

export default class Http {

  private path: string
  private http: any

  /**
   * @param {String} path
   * @param {Object} http
   */
  constructor(path: string, http = null, vs = null, baseURL = null) {
    this.path = path
    axiosStandard.setVs(vs)

    if (http) {
      this.http = http
    } else {
      this.http = axiosStandard.axios()
    }

  }

  /**
   * @param {String} path
   * @param {Object} options
   */
  static build(path: any, baseURL: any) {
    return new this(path, null, null, baseURL)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  get(url: string, data: any = null, extraOptions={}): Promise<any> {
    let params = new URLSearchParams()
    for (let key in data) {
      if (data[key] instanceof Object) {
        for (let objKey in data[key]) {
          let obj = data[key][objKey]
          if (obj instanceof Array) {
            obj.forEach(element => {
              params.append(`${key}[${objKey}][]`, element)
            })
          } else {
            params.append(`${key}[${objKey}]`, obj)
          }
        }
      } else {
        params.append(key, data[key])
      }
    }

    return this.http
      .get(Http.normalize(this.path, url), { params: params, ...extraOptions })
      .then(Http.then)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
   getBlob(url: string, data: any = null): Promise<any> {
    return this.get(url, data, {
      responseType: 'blob'
    })
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  post(url: string, data: any = {}, headers: any = {}): Promise<any> {

    return this.http
      .post(Http.normalize(this.path, url), data, {headers})
      .then(Http.then)
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  put(url: string, data: any, headers: any = {}) {
    return this.http.put(Http.normalize(this.path, url), data, {headers: headers}).then(Http.then)
  }

  /**
   * @param {String} url
   * @param {Object} data
   * @returns {*|Promise<any>}
   */
  patch(url: string, data: any) {
    return this.http.patch(Http.normalize(this.path, url), data).then(Http.then)
  }

  /**
   * @param {String} url
   * @returns {*|Promise<any>}
   */
  delete(url: string, data: any = undefined) {
    return this.http.delete(Http.normalize(this.path, url), {data: data}).then(Http.then)
  }

  /**
   * Download in the browser.
   * Obs.: Not supported to url presigned how aws s3
   * @param url
   * @param fileName
   * @param mimeType
   * @returns
   */
  download(url: string, fileName: string, mimeType: string) {
    return this.http
      .get(Http.normalize(this.path, url), {
        responseType: 'blob' as const // <- garante que é 'blob'
      })
      .then(response => {
        const blob = new Blob([response.data], { type: mimeType })
        console.log('fileName', fileName)
        console.log('mimeType', mimeType)

        // Internet Explorer
        if (window.navigator && window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, fileName)
          return
        }

        const blobURL = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobURL
        link.download = fileName

        // Fallback para Safari
        if (typeof link.download === 'undefined') {
          link.target = '_blank'
        }

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        // Cleanup
        setTimeout(() => {
          document.body.removeChild(link)
          URL.revokeObjectURL(blobURL)
        }, 100) // pequeno delay pra garantir que não revogue antes do download iniciar
      })
  }



  /**
   * @param {Object} response
   * @returns {Object}
   */
  static then(response: any) {
    if (!response.data) {
      return {}
    }
    if (typeof response.data === 'string') {
      return JSON.parse(response.data)
    }
    return response.data
  }

  /**
   * @param {String} start
   * @param {String} end
   * @returns {String}
   */
  static normalize(start: string, end?: string) {
    if (end === undefined || end === '') {
      return start;
    }
    const combined = `${start}/${end}`;
    return combined.replace(/([^:]\/)\/+/g, '$1');
  }
}
